var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBeauty = function SvgBeauty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m3.52 3.25 2.257 1.166c.464.24.755.719.755 1.24v4.538a.61.61 0 1 1-1.219 0V5.657a.18.18 0 0 0-.096-.159L2.96 4.333a.176.176 0 0 0-.256.158v5.703a.61.61 0 1 1-1.219 0V4.49a1.395 1.395 0 0 1 2.034-1.24",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.124 12.246a.61.61 0 0 1-.61.61h-5.01a.61.61 0 0 1-.61-.61v-2.008a.61.61 0 0 1 .61-.61h5.01a.61.61 0 0 1 .61.61zm-1.22-.61v-.789H2.113v.79z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.562 12.246a.61.61 0 0 1 .61-.61h5.674a.61.61 0 0 1 .609.61v6.984c0 .926-.75 1.676-1.676 1.676H2.24c-.926 0-1.677-.75-1.677-1.676zm1.219.61v6.374c0 .253.205.457.457.457H5.78a.457.457 0 0 0 .457-.457v-6.375zM8.05 17.453a.61.61 0 0 1 .61-.609h14.169a.61.61 0 0 1 .609.61v.002a3.385 3.385 0 0 1-3.385 3.386h-8.618a3.385 3.385 0 0 1-3.385-3.386zm1.305.61a2.17 2.17 0 0 0 2.08 1.56h8.618c.986 0 1.818-.659 2.08-1.56z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.492 11.546c0-4.012 3.246-7.267 7.252-7.267s7.252 3.255 7.252 7.267a7.27 7.27 0 0 1-3.905 6.448.6.6 0 0 1-.282.069h-6.13a.6.6 0 0 1-.282-.07 7.27 7.27 0 0 1-3.905-6.447m7.252-6.048c-3.33 0-6.033 2.707-6.033 6.048a6.05 6.05 0 0 0 3.121 5.298h5.824a6.05 6.05 0 0 0 3.12-5.298c0-3.342-2.701-6.048-6.032-6.048",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.744 7.976a3.57 3.57 0 0 0-3.565 3.574 3.57 3.57 0 0 0 3.565 3.575 3.57 3.57 0 0 0 3.565-3.575 3.57 3.57 0 0 0-3.565-3.574M10.96 11.55a4.79 4.79 0 0 1 4.784-4.793 4.79 4.79 0 0 1 4.784 4.794 4.79 4.79 0 0 1-4.784 4.793 4.79 4.79 0 0 1-4.784-4.794",
    clipRule: "evenodd"
  })));
};
export default SvgBeauty;